/*
 * @Author: 汪俊洪
 * @Date: 2021-06-22 14:08:20
 * @LastEditors: qx
 * @LastEditTime: 2022-10-18 15:03:07
 * @Description: 正则表达式
 */

// 大于0的正整数positive integer
export const positiveIntegerReg = /^[1-9]([0-9])*$/
// 手机号
export const phoneReg = /^1[3456789]\d{9}$/
// 传真 固话
export const faxReg = /^(\d{3,4}[-\\s]?)?\d{7,8}$/
// 手机号 固话
export const tellReg = /^(((\d{3,4}[-\\s]?)?\d{7,8})|(1[3456789]\d{9}))$/
// 身份证号
export const idCardReg = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/
// 密码规则 6-16位大小写加特殊符号
export const pwdReg = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,./]).{8,16}$/
// 必须以字母或者下划线开头
export const startWithoutNumber = /^[a-zA-Z_]([a-zA-Z0-9_]+)?$/
// 正整数
export const intReg = /^\+?[1-9][0-9]*$/
// 税号
export const taxReg = /^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/
// 统一社会信用代码
export const USCCReg = /[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g

export const urlReg = new RegExp('^((https|http|ftp|rtsp|mms)?://)' +
  '?(([0-9a-z_!~*\'().&=+$%-]+: )?[0-9a-z_!~*\'().&=+$%-]+@)?' + // ftp的user@
  '(([0-9]{1,3}.){3}[0-9]{1,3}' + // IP形式的URL- 123.123.123.123
  '|' + // 允许IP和DOMAIN（域名）
  '([0-9a-z_!~*\'()-]+.)*' + // 域名- www.
  '([0-9a-z][0-9a-z-]{0,61})?[0-9a-z].' + // 二级域名
  '[a-z]{2,6})' + // first level domain- .com or .museum
  '(:[0-9]{1,4})?' + // 端口- :80
  '((/?)|' + // a slash isn't required if there is no file name
  '(/[0-9a-z_!~*\'().;?:@&=+$,%#-]+)+/?)$')

export default {
  phoneReg,
  idCardReg,
  pwdReg
}
